import { useEffect } from "react";

const useLockScroll = (locked: boolean, tryRestoreScroll = true) => {
    useEffect(() => {
        if (locked) {
            const scrollY = window.scrollY;

            // Bloquea el scroll
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = "100%";
            document.body.style.overflow = "hidden";
        } else {
            // Restaura el scroll
            const scrollY = document.body.style.top;
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            document.body.style.overflow = "";

            // Vuelve a la posición original del scroll
            if (tryRestoreScroll) {
                window.scrollTo(0, parseInt(scrollY || "0") * -1);
            }
        }

        // Limpia el efecto cuando el componente se desmonta
        return () => {
            if (locked) {
                const scrollY = document.body.style.top;
                document.body.style.position = "";
                document.body.style.top = "";
                document.body.style.width = "";
                document.body.style.overflow = "";
                window.scrollTo(0, parseInt(scrollY || "0") * -1);
            }
        };
    }, [locked]);
};

export default useLockScroll;
